import { formatNumber } from './transform';

export const normalizeCurrencyCode = (code) =>
  String(code || 'UYU').trim().toUpperCase();

export const isUsdCurrency = (code) => normalizeCurrencyCode(code) === 'USD';

export const convertUsdToUyu = (usdAmount, rate) => {
  const amount = Number(usdAmount);
  const fx = Number(rate);
  if (!Number.isFinite(amount) || !Number.isFinite(fx) || fx <= 0) return null;
  return amount * fx;
};

export const toUyuAmount = (amount, currencyCode, usdRate) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return null;
  if (!isUsdCurrency(currencyCode)) return value;
  return convertUsdToUyu(value, usdRate);
};

/**
 * Formatea un importe con moneda.
 * Si es USD y hay cotización BCU: "USD 12,00 (UYU 480,00)"
 */
export const formatMoneyDual = (amount, currencyCode = 'UYU', usdRate) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '—';

  const code = normalizeCurrencyCode(currencyCode);
  const main = `${code} ${formatNumber(value)}`;

  if (!isUsdCurrency(code)) return main;

  const uyu = convertUsdToUyu(value, usdRate);
  if (uyu == null) return main;
  return `${main} (UYU ${formatNumber(uyu)})`;
};

export const formatMoneyCode = (amount, currencyCode = 'UYU') => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '—';
  return `${normalizeCurrencyCode(currencyCode)} ${formatNumber(value)}`;
};
